import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';

export class FormSession {
  private readonly state = new BehaviorSubject<string | null | undefined>(undefined);
  private revision = 0;

  constructor(destroy$: Subject<unknown>) {
    destroy$.pipe(take(1)).subscribe(() => this.invalidate());
  }

  pending(): void {
    this.state.next(undefined);
  }

  invalidate(): void {
    this.revision++;
    this.state.next(null);
  }

  ready(key: string): void {
    this.state.next(key);
  }

  ticket(key: string): { key: string; revision: number } {
    return { key, revision: this.revision };
  }

  async run<T>(ticket: { key: string; revision: number }, action: () => T): Promise<Awaited<T> | undefined> {
    while (true) {
      if (ticket.revision !== this.revision) return undefined;
      await firstValueFrom(this.state.pipe(filter((state) => state !== undefined), take(1)));
      const state = this.state.value;
      if (ticket.revision !== this.revision) return undefined;
      if (state === undefined) continue;
      if (state !== ticket.key) return undefined;
      return await action();
    }
  }
}
